var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 59.81817626953125,
    height: 59.9993896484375,
    viewBox: "0 0 59.81817626953125 59.9993896484375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1_545"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D34",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#841600",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.617,28.2721C19.2714,28.2721,18.3097,26.9701,18.7055,25.6839L25.7675,2.73213C26.284,1.05377,27.8258,-0.0996723,29.5786,0.00680547Q31.0727,0.0975691,32.8182,0.272115Q34.2691,0.41721,35.6043,0.678096Q44.3842,2.26754,51.058,8.94138Q59.8182,17.7016,59.8182,30.0903Q59.8182,42.4791,51.058,51.2392Q42.2978,59.9994,29.9091,59.9994Q17.5204,59.9994,8.76017,51.2392Q0,42.4791,0,30.0903Q0,16.8013,9.58679,8.12676L8.5356,6.7284C8.03037,6.05632,8.5297,5.09866,9.36999,5.12813L16.386,5.37423C17.3406,5.40771,18.0212,6.31304,17.7881,7.23935L16.0749,14.0474C15.8698,14.8628,14.8111,15.0764,14.3058,14.4043L13.2128,12.9503Q6,19.7857,6,30.0903Q6,39.9938,13.0028,46.9966Q20.0056,53.9994,29.9091,53.9994Q39.8126,53.9994,46.8154,46.9966Q53.8182,39.9938,53.8182,30.0903Q53.8182,20.1868,46.8154,13.184Q42.7441,9.1128,37.6925,7.40846L33.9091,20.2721L43.4936,20.2721C45.1831,20.2721,46.1115,22.2373,45.0384,23.5423L27.7593,44.5574C26.3475,46.2745,23.6077,44.7522,24.3199,42.6464L29.1818,28.2721L20.617,28.2721Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1_545)",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt1);
export default __webpack_public_path__ + "static/media/opt1.1e5db68a3b46faf56f646060ba349dc8.svg";
export { ForwardRef as ReactComponent };